export default __webpack_public_path__ + "static/media/victorOkeke.d36df292.jpg";